<template lang="pug">
  SspLayout.recall(area="tnt")
    template(slot="actions")
      button.btn.btn-primary.ml10(v-if="recall && recall.status === 'PENDING'" @click="confirmRecall()") Confirm Recall
      button.btn.btn-danger(v-if="recall && recall.status === 'PENDING'" @click="rejectRecall()") Reject Recall
    .row
      .col-sm-6
         .panel.panel-default
            .panel-heading
              .panel-title Details
            .panel-body(v-if="recall")
              .container-fluid
                .row
                  label.col-sm-4.control-label Status
                  .col-sm-8
                    span {{recall.status}}

                .row
                  label.col-sm-4.control-label Recaller
                  .col-sm-8
                    span(v-if="recall.recaller") {{recall.recaller.username}}

                .row
                  label.col-sm-4.control-label Type
                  .col-sm-8
                    span {{recall.type}}

                .row
                  label.col-sm-4.control-label Recall
                  .col-sm-8
                    router-link(v-if="recall.orderId" :to="{name: 'order', params: { id: recall.orderId }}") {{'Order ' + recall.orderId }}
                    a(v-if="recall.sectionId" @click="goToSection()") {{'Section ' + recall.sectionId}}
                    router-link.kzcode-default(v-if="recall.recallCodes" :to="{name: 'dissectorWithCode', params: { code: recall.recallCodes[0] }}") {{recall.recallCodes[0]}}
                .row
                  label.col-sm-4.control-label Total Codes
                  .col-sm-8
                    span {{totalCodes}}

                .row
                  label.col-sm-4.control-label Consumer Validations
                  .col-sm-8
                    span {{consumerCount}}

                .row
                  label.col-sm-4.control-label Created
                  .col-sm-8
                    span {{recall.timestamp | date}}

      .col-sm-6
        GenericTable(v-if="progress")
          tr(slot="thead")
            th Package Type
            th Product
            th Initial
            th Retrieved
            th Remaining
          tr(v-for="p in progress")
            td
              router-link(:to="{name: 'packageEdit', params: {id: p.productPackage.packageTypeId}}" v-if="p.productPackage") {{p.productPackage.packageTypeName}}
            td
              router-link(:to="{name: 'product', params: {id: p.productPackage.productId}}" v-if="p.productPackage.productName") {{p.productPackage.productName}}
            td {{p.progress.initial}}
            td {{p.progress.completed}} ({{p.progress.completedPercentage}} %)
            td {{p.progress.remaining}} ({{p.progress.remainingPercentage}} %)

    .row
      .col-sm-6
        DataGrid(ref="grid" :fetch="getRecallInventory" @error="$emit('error', $event)")
          tr.header(slot="thead")
            th Location
            th Product
            th Package
            th Total
          template(v-for="l in locations")
            tr
              td(colspan="4")
                a.fa(@click="l.expanded = !l.expanded" :class="{ 'fa-chevron-down': l.expanded, 'fa-chevron-right': !l.expanded}")
                a.ml10(:href="`#/trackntrace/dashboards/locationportal/${l.location.id}/packagetype`") {{l.location.name}}
            tr(v-if="l.expanded" v-for="i in l.inventory")
              td
              td
                span(v-if="i.productName") {{i.productName}}
              td
                span(v-if="i.packageName") {{i.packageName}}
              td
                span(v-if="i.count") {{i.count}}
</template>

<script>
import miniToastr from 'mini-toastr'
import TrackNTrace from '@/service/apis/TrackNTrace'
import Core from '@/service/apis/Core'
import { dateFilter } from '@/filters/filters'
import GenericTable from '@/components/common/GenericTable'
import DataGrid from '@/components/ssp/DataGrid'

export default {
  data: () => ({
    recall: null,
    progress: null,
    locations: null,
    consumerCount: null,
    totalCodes: null
  }),
  created() {
    this.getRecall()
  },
  methods: {
    rejectRecall() {
      TrackNTrace.recallReject(this.recallId)
        .then(() => {
          miniToastr.success('Recall successfully rejected')
          this.$router.push({ name: 'recalls' })
        })
        .catch((e) => {
          this.errorMsg = this.error(e)
        })
    },
    confirmRecall() {
      TrackNTrace.recallConfirm(this.recallId)
        .then(() => {
          miniToastr.success('Recall successfully confirmed')
          this.$router.push({ name: 'recalls' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    getRecall() {
      TrackNTrace.getRecall(this.recallId)
        .then((resp) => {
          this.recall = resp.data.recall
          this.progress = resp.data.progress.details
          this.consumerCount = resp.data.consumerCount
          this.totalCodes = resp.data.totalCodes
        })
    },
    getRecallInventory() {
      return TrackNTrace.getRecallInventoryByLocation(this.recallId)
        .then((resp) => {
          this.locations = resp.data.content.map((l) => {
            const location = l
            location.expanded = false
            return location
          })
          return resp.data.totalElements
        })
    },
    goToSection() {
      Core.getSection(this.recall.sectionId)
        .then((resp) => {
          this.$router.push({ name: 'section', params: { orderId: resp.data.orderId, sectionId: this.recall.sectionId } })
        })
    }
  },
  computed: {
    recallId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    GenericTable,
    DataGrid
  },
  filters: {
    date: dateFilter
  }
}
</script>

<style lang="scss">
.recall {
  .header {
    th {
      width: 25%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/configuration/recall/Recall.vue